// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3jdut","unreadBadge":"styles_unreadBadge__2c90U","modalContent":"styles_modalContent__3x82d","modal":"styles_modal__3GUi9"};